import { apiResponseModalSliceDispatch } from "../../Constants/ReduxConstants";

interface ApiResponseModalState {
    open: boolean,
    openedFileFromApi: boolean
}

//Every reducer needs initial state.
const initialState: ApiResponseModalState = {
    open: false,
    openedFileFromApi: false
}

export default function apiResponseModallice(state = initialState, action: { type: any; payload: any; }) {
    switch (action.type) {
        case apiResponseModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case apiResponseModalSliceDispatch.setOpenedFileFromApi: {
            return {
                ...state,
                openedFileFromApi: action.payload
            }
        }
        default:
            return state
    }
}